// Таблица всех замеров: новые сверху, неполные помечены, строка ведёт в карточку; «Скачать CSV».

import { Link, useNavigate } from 'react-router-dom'

import { Badge, Card, Icon } from '@/components/ui'
import { formatDate, formatNumber } from '@/lib/format'

import { inbodyApi, type ScanField, type ScanOut } from '../api'
import { FIELD_LABELS } from '../labels'

const COLUMNS: readonly ScanField[] = [
  'weight_kg',
  'skeletal_muscle_kg',
  'body_fat_pct',
  'body_fat_kg',
  'fat_free_mass_kg',
  'total_body_water_l',
  'score',
]

const linkButton =
  'inline-flex min-h-9 items-center gap-1.5 rounded-lg border border-border bg-surface px-3 text-sm font-medium text-fg hover:bg-surface-2'

export function ScansTable({ scans }: { scans: ScanOut[] }) {
  const navigate = useNavigate()
  return (
    <Card
      flush
      title="Все замеры"
      actions={
        <a href={inbodyApi.exportCsvUrl()} download className={linkButton}>
          <Icon name="download" size={16} />
          Скачать CSV
        </a>
      }
    >
      <div className="overflow-x-auto">
        <table className="w-full min-w-[34rem] text-sm">
          <thead>
            <tr className="border-b border-border text-left text-xs text-muted">
              <th className="px-4 py-2 font-medium">Дата</th>
              {COLUMNS.map((field) => (
                <th key={field} className="px-2 py-2 text-right font-medium">
                  {FIELD_LABELS[field].label}
                  {FIELD_LABELS[field].unit ? `, ${FIELD_LABELS[field].unit}` : ''}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {scans.map((scan) => (
              <tr
                key={scan.id}
                className="cursor-pointer hover:bg-surface-2"
                onClick={() => navigate(`/health/inbody/${scan.id}`)}
              >
                <td className="whitespace-nowrap px-4 py-2">
                  <Link
                    to={`/health/inbody/${scan.id}`}
                    onClick={(event) => event.stopPropagation()}
                    className="font-semibold text-fg hover:underline"
                  >
                    {formatDate(scan.day)}
                  </Link>
                  {!scan.complete ? <Badge className="ml-2">неполный</Badge> : null}
                </td>
                {COLUMNS.map((field) => (
                  <td key={field} className="px-2 py-2 text-right tabular-nums text-fg">
                    {formatNumber(scan[field] ?? null, { digits: FIELD_LABELS[field].digits })}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  )
}
